import React from 'react'
import classNames from 'classnames/bind'
import { Board } from './board'

import styles from './App.scss'

const css = classNames.bind(styles)

export const App = () => {
  const sounds = [
    {
      title: 'Rock your day!',
      src: '/assets/rock%20your%20day.mp3'
    },
    {
      title: 'Crazy things',
      src: '/assets/crazy%20things.mp3'
    },
    {
      title: 'But remember',
      src: '/assets/but%20remember.mp3'
    },
    {
      title: 'Good',
      src: '/assets/good.mp3'
    },
    {
      title: 'Peepol',
      src: '/assets/peepol.mp3'
    },
    {
      title: 'You need to protec yourself',
      src: '/assets/protec.mp3'
    },
    {
      title: 'Push yourself',
      src: '/assets/push%20yurself.mp3'
    },
    {
      title: 'You need to',
      src: '/assets/you%20need%20to.mp3'
    },
    {
      title: 'Tädää',
      src: '/assets/tadaa.mp3'
    },
    {
      title: 'This is your day',
      src: '/assets/this%20is%20your%20day.mp3'
    },
    {
      title: 'Remember',
      src: '/assets/remember.mp3'
    },
    {
      title: 'Attitude',
      src: '/assets/attitude.mp3'
    }
  ]

  return (
    <div className={css('container-fluid')}>
      <h1 className={css('text-center', 'py-3', 'text-white', 'display-3')}>
        Rock Your Day!!!!
        <small className={css('text-muted')}> Soundboard</small>
      </h1>
      <div className={css('jumbotron-fluid')}>
        <Board sounds={sounds} />
      </div>
      <div className={css('image-container', 'text-center')}></div>
    </div>
  )
}
